// extracted by mini-css-extract-plugin
export default {"gridRow":"grid-row_gridRow__m3A+j"};